import { render, staticRenderFns } from "./LogDashboard.vue?vue&type=template&id=f13a59f2&"
import script from "./LogDashboard.vue?vue&type=script&lang=js&"
export * from "./LogDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f13a59f2')) {
      api.createRecord('f13a59f2', component.options)
    } else {
      api.reload('f13a59f2', component.options)
    }
    module.hot.accept("./LogDashboard.vue?vue&type=template&id=f13a59f2&", function () {
      api.rerender('f13a59f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/LogDashboard.vue"
export default component.exports